/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function DiffViewSplit({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" d="M13 1.4A2.6 2.6 0 0 1 15.6 4v8a2.6 2.6 0 0 1-2.6 2.6H3A2.6 2.6 0 0 1 .4 12V4A2.6 2.6 0 0 1 3 1.4zM3 2.6A1.4 1.4 0 0 0 1.6 4v8A1.4 1.4 0 0 0 3 13.4h10a1.4 1.4 0 0 0 1.4-1.4V4A1.4 1.4 0 0 0 13 2.6z" /><path fill="currentColor" d="M2.35 4.297a1 1 0 0 1 1-1h3.3a1 1 0 0 1 1 1v7.406a1 1 0 0 1-1 1h-3.3a1 1 0 0 1-1-1z" /><path fill="#DBD8D6" d="M8.35 4.297a1 1 0 0 1 1-1h3.3a1 1 0 0 1 1 1v7.406a1 1 0 0 1-1 1h-3.3a1 1 0 0 1-1-1z" /></svg>;
}
;